<template>
    <div class="grid grid-cols-12 gap-4 px-5 py-4 mb-8">
        <div
            class="
                credit-score
                col-span-12
                lg:col-span-6
                xl:col-span-4
                rounded-lg
                bg-white
                px-4
                pt-5
                pb-12
                shadow
                sm:px-6
                sm:pt-6
                border border-gray-200
                flex flex-col
                justify-between
            "
        >
            <p class="text-base text-gray-800 mb-2">
                <span
                    class="font-bold text-lg"
                    :class="{
                        'text-green-400':
                            userScoreData.prev_score_change_notation === '+',
                        'text-red-400':
                            userScoreData.prev_score_change_notation === '-',
                    }"
                    >{{ userScoreData.prev_score_change_notation
                    }}{{ userScoreData.prev_score_change }}</span
                >
                Since Last Update
            </p>

            <div class="relative -mt-3">
                <creditscore-meter></creditscore-meter>
            </div>

            <div>
                <div
                    v-if="userScoreData.last_updated_days < 60"
                    class="flex w-full items-center justify-between px-2"
                >
                    <div>
                        <p class="text-sm text-gray-400">
                            Score Last Updated:
                            <span class="text-green-400">{{
                                userScoreData.last_updated
                            }}</span>
                        </p>
                    </div>
                    <div class="program-name">
                        <div
                            class="
                                border-2 border-gray-200
                                px-3
                                pt-1
                                pb-1
                                rounded
                            "
                        >
                            <p><i class="fal fa-check text-green-400"></i></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="
                credit-score-history
                col-span-12
                lg:col-span-6
                xl:col-span-8
                rounded-lg
                bg-white
                px-4
                pt-5
                pb-12
                shadow
                sm:px-6
                sm:pt-6
                border border-gray-200
            "
        >
            <creditscore-history></creditscore-history>

            <button
                type="button"
                class="btn btn-primary"
                @click.prevent="openCreditScoreModal"
            >
                <i class="far fa-plus mr-2 text-lg text-amber-600"></i> Add
                Score
            </button>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useCreditScoreStore } from "@/store/creditscore";
import CreditscoreHistory from "@/charts/creditscore/history.vue";
import CreditscoreMeter from "@/charts/creditscore/meter.vue";

export default {
    props: {},
    components: {
        CreditscoreHistory,
        CreditscoreMeter,
    },
    data: () => ({}),
    directives: {},
    computed: {
        ...mapState(useCreditScoreStore, ["userScoreData"]),
    },
    methods: {
        ...mapActions(useCreditScoreStore, [
            "setTabState",
            "openCreditScoreModal",
        ]),
    },
    mounted() {},
};
</script>
